import { Pipe, PipeTransform } from '@angular/core';
/** credit: https://stackoverflow.com/a/46034728/7403919 */
@Pipe({
  name: 'iterate'
})
export class IteratePipe implements PipeTransform {

  transform(value: number): any {
    const iterable = <Iterable<any>> {};
    iterable[Symbol.iterator] = function* () {
      let n = 0;
      while (n < value) {
        yield (++n)-1;
      }
    };
    return iterable;
  }

}

